module.exports = __webpack_public_path__ + "static/media/AddCircleIcon.ccf13f15.svg";